import {
  CALCULATE_BASKET_PRICE_REQUEST,
  CALCULATE_BASKET_PRICE_SUCCESS,
  CALCULATE_BASKET_PRICE_FAILURE
} from '../../actionTypes/calculateBasketPriceActionTypes'

const calculateBasketPriceRequest = payload => ({
  type: CALCULATE_BASKET_PRICE_REQUEST,
  payload
})

const calculateBasketPriceSuccess = payload => ({
  type: CALCULATE_BASKET_PRICE_SUCCESS,
  payload
})

const calculateBasketPriceFailure = payload => ({
  type: CALCULATE_BASKET_PRICE_FAILURE,
  payload
})

export { calculateBasketPriceRequest, calculateBasketPriceSuccess, calculateBasketPriceFailure }
